export default "__VITE_ASSET__BZMxIMmW__"